import React, { useEffect, useState } from "react";
import { Loader } from "lucide-react";
const BASE = "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com";

export default function PaySim() {
  const [status, setStatus] = useState("processing"); // 'processing' | 'done' | 'error'
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    if (!u?.email) { window.location.assign("/login"); return; }

    (async () => {
      try {
        const res = await fetch(`${BASE}/pay_simulate`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: u.email })
        });
        const data = await res.json();
        if (data?.status === "success") {
          setStatus("done");
          setMsg("Attivazione completata.");
          // clear any cached PI or promo placeholders
          sessionStorage.removeItem("teche_pi_client_secret");
          sessionStorage.removeItem("teche_pi_total");
          sessionStorage.removeItem("applied_discount_code");
          // hop to library/account
          setTimeout(() => window.location.assign("/mytours"), 1000);
        } else {
          setStatus("error");
          setMsg(data?.message || "Errore durante l'attivazione.");
        }
      } catch {
        setStatus("error");
        setMsg("Errore di rete.");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="bg-white rounded-xl shadow p-8 max-w-md w-full text-center">
        {status === "processing" && (
          <>
            <Loader className="animate-spin mx-auto mb-3" size={36} />
            <div>Sto attivando il tuo acquisto…</div>
          </>
        )}
        {status === "done" && <div className="text-green-700 font-semibold">{msg}</div>}
        {status === "error" && <div className="text-red-700 font-semibold">{msg}</div>}
      </div>
    </div>
  );
}
